export default [
  {
    path: '/settings/return-reason-types',
    name: 'return-reason-type-list',
    component: () => import('@/views/settings/ReturnReasonTypes.vue'),
    meta: {
      pageTitle: 'Motif de retour',
      breadcrumb: [
        { text: 'Paramètres', to: { name: 'parameters' } },
        { text: 'Motif de retour', active: true },
      ],
      requiresAdmin: true,
    },
  },
  {
    path: '/settings/parameters',
    name: 'parameters',
    component: () => import('@/views/settings/Parameters.vue'),
    meta: {
      pageTitle: 'Paramètres',
      breadcrumb: [
        { text: 'Paramètres', active: true },
      ],
      roles: ['admin', 'superadmin', 'admin_developer'],
      requireLogin: true,
    },
  },
  {
    path: '/settings/parameters/supplier-bordereau-display',
    name: 'supplier-bordereau-display-parameters',
    component: () => import('@/views/settings/Parameters.vue'),
    meta: {
      pageTitle: 'Paramètres Bordereaux',
      breadcrumb: [
        { text: 'Paramètres', to: { name: 'parameters' } },
        { text: 'Bordereaux fournisseur', active: true },
      ],
      roles: ['admin', 'superadmin'],
      requireLogin: true,
    },
  },
]
